import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const getMyTeamDetails = createAsyncThunk('getMyTeamDetails', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/tpo/my-team/${obj.id}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const myTeamDetailsSlice = createSlice({
    name: 'Round Details',
    initialState: {
        loading: false,
        teamDetails: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getMyTeamDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getMyTeamDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.teamDetails = action.payload
        })
        builder.addCase(getMyTeamDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default myTeamDetailsSlice.reducer